var exports = {
  "Q": "celebrate__M1vozU",
};

module.exports = exports;
